import type { ReactNode } from 'react';

import TabBody from './TabBody';
import TabsContext from './TabContext';
import TabHeader from './TabHeader';
import type { Tab } from './types';

type Props = {
  tabs: Tab[];
  selectedTabId?: StringNumberValue | null;
  children?: ReactNode;
};

const Tabs = ({ tabs, selectedTabId, children }: Props) => {
  return (
    <TabsContext.Provider value={{ tabs, selectedTabId }}>
      {children}
    </TabsContext.Provider>
  );
};

Tabs.TabHeader = TabHeader;
Tabs.TabBody = TabBody;

export default Tabs;
